const { databaseServer } = require('../config/network');

const getUsers = async (token, collectionId) => {
    return fetch(`${databaseServer}/users`, {
        headers: new Headers({
            'Authorization': token
        })
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const getUsersById = async (token, id) => {
    return fetch(`${databaseServer}/users/${id}`,{
        headers: new Headers({
            'Authorization': token
        })})
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const createUser = async (token, user) => {
    return fetch(`${databaseServer}/users`, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify(user),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const editUserOnDb = async (token, user) => {
    return fetch(`${databaseServer}/users/${user.id}`, {
        method: 'put',
        mode: 'cors',
        body: JSON.stringify(user),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const deleteUserFromDb = async (token, id) => {
    return fetch(`${databaseServer}/users/${id}`, {
        method: 'delete',
        mode: 'cors',
        headers: new Headers({
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

module.exports = {
    getUsers,
    getUsersById,
    createUser,
    deleteUserFromDb,
    editUserOnDb,
}